import React, { Component } from 'react';
import './App.css';
import PvWrapper from './PvWrapper';
import StartScreen from './StartScreen';
import ExitScreen from './ExitScreen';
import CamErrorScreen from './CamErrorScreen';
import ErrorScreen from './ErrorScreen';
import LoadingScreen from './LoadingScreen';

import log from './utils/log';
import Cookies from 'universal-cookie';
import i18next from 'i18next';
import { withTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { isSafari, isMobileSafari } from "react-device-detect";
import PvCreateForm from './PvCreateForm';

const sameKlamstwa = {
  DisplayStartScreen: false,
  DisplayPvWebcamWrapper: false,
  DisplayExitScreen: false,
  DisplayLoadingScreen: false,
  DisplayCamErrorScreen: false,
  DisplayErrorScreen: false,
  DisplayPvCreateForm: false
};


class App extends Component {
  constructor(props) {
    super(props);



    let PvApiUrl = process.env.REACT_APP_PV_API_URL
    // let hostname = ''
    // let url = ''
    console.log('hostname', window.location.hostname)
    console.log('location', window.location)


    if (window.location.hostname === 'localhost'){
      PvApiUrl = 'https://localhost:8000/api/v1'
    } else  if (window.location.hostname === 'dev.igoriacard.com'){
      if (window.location.pathname.startsWith('/icm')){
        PvApiUrl = 'https://localhost:8000/api/v1'
      } else {
        PvApiUrl = 'https://localhost:8000/api/v1'
      }
    }
    else  if (window.location.hostname === 'dev.trejdoo.com'){
      PvApiUrl = 'https://localhost:8000/api/v1'
    }
    else  if (window.location.hostname === 'dev.igsoncapital.com'){
      PvApiUrl = 'https://localhost:8000/api/v1'
    }
    else  if (window.location.hostname === 'dev.wmcsepa.com'){
      PvApiUrl = 'https://localhost:8000/api/v1'
    }
    else if (window.location.hostname === 'alpha.igoriacard.com'){
      if (window.location.pathname.startsWith('/icm')){
        PvApiUrl = 'https://alpha.api.pv.igoriatrade.com/api/v1'
      } else {
        PvApiUrl = 'https://alpha.api.pv.igoriatrade.com/api/v1'
      }
    }
    else if (window.location.hostname === 'alpha.trejdoo.com'){
      PvApiUrl = 'https://alpha.api.pv.igoriatrade.com/api/v1'
    }
    else  if (window.location.hostname === 'alpha.igsoncapital.com'){
      PvApiUrl = 'https://alpha.api.pv.igoriatrade.com/api/v1'
    }
    else  if (window.location.hostname === 'alpha.wmcsepa.com'){
      PvApiUrl = 'https://alpha.api.pv.igoriatrade.com/api/v1'
    }
    else if (window.location.hostname === 'uat.igoriacard.com'){
      if (window.location.pathname.startsWith('/icm')){
        PvApiUrl = 'https://uat.api.pv.igoriatrade.com/api/v1'
      } else {
        PvApiUrl = 'https://uat.api.pv.igoriatrade.com/api/v1'
      }
    }
    else if (window.location.hostname === 'uat.trejdoo.com'){
      PvApiUrl = 'https://uat.api.pv.igoriatrade.com/api/v1'
    }
    else  if (window.location.hostname === 'uat.igsoncapital.com'){
      PvApiUrl = 'https://uat.api.pv.igoriatrade.com/api/v1'
    }
    else  if (window.location.hostname === 'uat.wmcsepa.com'){
      PvApiUrl = 'https://uat.api.pv.igoriatrade.com/api/v1'
    }
    else if (window.location.hostname === 'igoriacard.com'){
      if (window.location.pathname.startsWith('/icm')){
        PvApiUrl = 'https://api.pv.igoriatrade.com/api/v1'
      } else {
        PvApiUrl = 'https://api.pv.igoriatrade.com/api/v1'
      }
    }
    else if (window.location.hostname === 'trejdoo.com'){
      PvApiUrl = 'https://api.pv.igoriatrade.com/api/v1'
    }
    else  if (window.location.hostname === 'igsoncapital.com'){
      PvApiUrl = 'https://api.pv.igoriatrade.com/api/v1'
    }
    else  if (window.location.hostname === 'login.wmcsepa.com'){
      PvApiUrl = 'https://api.pv.igoriatrade.com/api/v1'
    }
    console.log('PvApiUrl', PvApiUrl)

    if (this.props.PvApiUrl) {
      PvApiUrl = this.props.PvApiUrl
    }
    console.log('this.props.PvApiUrl', this.props.PvApiUrl)
    console.log('PvApiUrl2', PvApiUrl)
    this.state = {
      DisplayStartScreen: true,
      DisplayPvWebcamWrapper: false,
      DisplayExitScreen: false,
      DisplayLoadingScreen: false,
      DisplayCamErrorScreen: false,
      DisplayErrorScreen: false,
      DisplayPvCreateForm: false,
      ServerErrorHeader: null,
      ServerErrorMessage: null,
      ServerErrorMessageBottomText: null,
      PvApiUrl: PvApiUrl,

    };

    const urlParams = new URLSearchParams(window.location.search);
    const cookies = new Cookies();
    const langCookieValue = cookies.get("LangCookieKey");

    var lang = 'pl';
    if (urlParams.has('lang')) {
      lang = urlParams.get('lang')
    }
    if (langCookieValue){
      const langCookieValueParsed = new URLSearchParams(langCookieValue)
      const CultureName = langCookieValueParsed.get("CultureName")
      lang = CultureName.slice(0, 2)
    }
    console.log('lang', lang)
    cookies.set('lang', lang, { path: '/' });
    i18next.changeLanguage(lang, console.log);
  }


  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);

    var pvUuid = urlParams.get('pv_uuid');
    console.log(pvUuid)
    if (pvUuid) {
      const autoStart = urlParams.get('auto_start');
      this.fetchPvUuidIsActive(pvUuid)
      if (autoStart === 'true') {
        this.handleStartButtonClick();
        this.fetchStatusIdUpdateAfterStart();
      }
    } else {
      this.setDisplayPvCreateFormState()
    }
    // if (isSafari || isMobileSafari) {
    //   log("Safari detected");
    //   this.setState({
    //     ServerErrorHeader: 'SAFARI_NOT_SUPPORTED_ERROR',
    //     ServerErrorMessage: 'Aplikacja nie działa w przeglądarce Safari',
    //     ServerErrorMessageBottomText: 'Aby uzyskać najlepszy efekt, użyj Chrome lub Firefox',
    //   });
    //   this.setDisplayErrorScreenState();
    // }

  }


  handleStartButtonClick = () => {
    log("handleStartButtonClick");
    const newState = { ...sameKlamstwa };
    newState.DisplayPvWebcamWrapper = true;
    this.setState(newState);
  }

  handleDisplayExitScreen = () => {
    log("handleDisplayExitScreen");
    const newState = { ...sameKlamstwa };
    newState.DisplayExitScreen = true;
    this.setState(newState);
  }

  handleUserMediaError = (error) => {
    log("handleUserMediaError");
    console.log("handleUserMediaError");
    console.log(error);
    const newState = { ...sameKlamstwa };
    newState.DisplayCamErrorScreen = true;
    this.setState(newState);
  }

  setDisplayErrorScreenState = () => {
    const newState = { ...sameKlamstwa };
    newState.DisplayErrorScreen = true;
    this.setState(newState);
  }
  setDisplayPvCreateFormState = () => {
    const newState = { ...sameKlamstwa };
    newState.DisplayPvCreateForm = true;
    this.setState(newState);
  }

  setDisplayLoadingScreenState = () => {
    const newState = { ...sameKlamstwa };
    newState.DisplayLoadingScreen = true;
    this.setState(newState);
  }

  handleICEError = (code, msg) => {
    this.setState({
      ServerErrorHeader: `E${code}: ${msg}`,
      ServerErrorMessage: 'Nawiązanie połączenia wideo nie powiodło się. Spróbuj ponownie za kilka minut.',
      ServerErrorMessageBottomText: 'Jeżeli problem się powtarza, skontaktuj się z obsługą klienta.'
    })
    this.setDisplayErrorScreenState()
  }

  handleServerError = (code, msg) => {
    this.setState({
      ServerErrorHeader: `HTTP ${code}: ${msg}`,
      ServerErrorMessage: 'Aplikacja napotkała błąd.',
      ServerErrorMessageBottomText: 'Skontaktuj się z obsługą klienta.'
    })
    this.setDisplayErrorScreenState()
  }

  handleCustomServerError = (code, msg) => {

    console.log(`E${code}: ${msg}`)
    log(`handleServerError E${code}: ${msg}`);
    let ServerErrorMessage = "";
    let ServerErrorMessageBottomText = 'Skontaktuj się z obsługą klienta.';
    if (code === 103 && msg === 'PV_UUID_MISSING') {
      ServerErrorMessage = 'Brak identyfikatora wideoweryfikacji';
    } else if (code === 104 && msg === 'PROVIDED_PV_UUID_DOES_NOT_EXIST') {
      ServerErrorMessage = 'Identyfikator wideoweryfikacji jest nieprawidłowy.';
    } else if (code === 105 && msg === 'INACTIVE_PV_UUID') {
      ServerErrorMessage = 'Identyfikator wideoweryfikacji jest nieaktywny.';
    } else if (code === 201 && msg === 'SERVER_OVERLOAD') {
      ServerErrorMessage = 'Serwer wideoweryfikacji jest przeciążony. Spróbuj ponownie za kilka minut.';
      ServerErrorMessageBottomText = 'Jeżeli problem się powtarza, skontaktuj się z obsługą klienta.';
    }
    this.setState({
      ServerErrorHeader: `E${code}: ${msg}`,
      ServerErrorMessage,
      ServerErrorMessageBottomText
    })
    this.setDisplayErrorScreenState()

  }

  fetchPvUuidIsActive = (pvUuid) => {
    fetch(`${this.state.PvApiUrl}/pv_session/${pvUuid}/is_active`).then(response => {
      if (response.status === 200) {
        response.json().then(data => {
          console.log(data)
          if (data) {
            console.log("PV_UUID_ACTIVE")
          } else {
            this.handleCustomServerError(105, 'INACTIVE_PV_UUID')
          }
        })
      } else if (response.status === 404) {
        this.handleCustomServerError(104, 'PROVIDED_PV_UUID_DOES_NOT_EXIST')
      } else {
        this.handleServerError(response.status, response.statusText)
      }
    }).catch(error => {
      this.handleServerError(1000, error)
    })
  }

  fetchStatusIdUpdateAfterStart = () => {
    console.log('dupa')
    const url = `${this.props.PvApiUrl}/pv_session/${this.pv_uuid}/status`
    console.log(url)
    console.log("wysyłam POST do API z buttonClick...")
    fetch(url, {
        method: 'POST'
    }).then((response) => {
        console.log("odpowiedz od API")
        console.log(response)
    }).catch((error) => {
        console.log('warning')
        console.log(error)
    })
  }





  render() {
    const { t } = this.props;

    return (
      <div className="App">
        <Helmet>
          <title>{t("Wideoweryfikacja")}</title>
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        </Helmet>
        {this.state.DisplayStartScreen && <StartScreen
          handleStartButtonClick={this.handleStartButtonClick} />}

        {this.state.DisplayPvWebcamWrapper && <PvWrapper
          handleDisplayExitScreen={this.handleDisplayExitScreen}
          handleUserMediaError={this.handleUserMediaError}
          handleCustomServerError={this.handleCustomServerError}
          handleServerError={this.handleServerError}
          handleICEError={this.handleICEError}
          setDisplayLoadingScreenState={this.setDisplayLoadingScreenState}
          PvApiUrl={this.state.PvApiUrl}
          // fetchStatusIdUpdateAfterStart={this.fetchStatusIdUpdateAfterStart}
        />}

        {this.state.DisplayExitScreen && <ExitScreen />}

        {this.state.DisplayLoadingScreen && <LoadingScreen />}

        {this.state.DisplayCamErrorScreen && <CamErrorScreen
          handleStartButtonClick={this.handleStartButtonClick} />}

        {!this.state.DisplayExitScreen && this.state.DisplayErrorScreen && <ErrorScreen
          header={this.state.ServerErrorHeader}
          text={this.state.ServerErrorMessage}
          bottomText={this.state.ServerErrorMessageBottomText} />}

        {this.state.DisplayPvCreateForm && <PvCreateForm />}
      </div>
    );
  }
}

export default withTranslation()(App);
